import React from 'react';
import { useLanguage } from './LanguageContext';
import { artwork } from './artwork';
export function Footer() {
  const {
    t
  } = useLanguage();
  const currentYear = new Date().getFullYear();
  return <footer className="bg-slate-50 py-12 border-t border-slate-100" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-122">
          <div className="flex items-center space-x-4 text-center md:text-left" data-id="element-123">
            <img src={artwork.LOGO_IMAGE} alt="Aissa Edon Logo" className="w-12 h-12 rounded-full object-cover border border-teal-100 shadow-sm hidden md:block" data-id="element-124" />
            <div data-id="element-125">
              <h3 className="text-xl font-serif font-medium text-teal-900 mb-1" data-id="element-126">
                {t.footer.name}
              </h3>
              <p className="text-slate-500 text-sm" data-id="element-127">{t.footer.role}</p>
            </div>
          </div>

          <div className="flex items-center space-x-6 text-sm text-slate-500" data-id="element-128">
            <a href="#home" className="hover:text-teal-600 transition-colors" data-id="element-129">
              {t.nav.home}
            </a>
            <a href="#services" className="hover:text-teal-600 transition-colors" data-id="element-130">
              {t.nav.services}
            </a>
            <a href="#clinic" className="hover:text-teal-600 transition-colors" data-id="element-131">
              {t.nav.clinic}
            </a>
            <a href="#contact" className="hover:text-teal-600 transition-colors" data-id="element-132">
              {t.nav.contact}
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400" data-id="element-133">
          <p data-id="element-134">
            © {currentYear} {t.footer.name}. {t.footer.rights}
          </p>
          <p data-id="element-135">EN | FR</p>
        </div>
      </div>
    </footer>;
}